module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no9-fc4bca15503df3f9743b72e7c01dd807.png";